import { SVG } from '../SVG'

export const ListIcon = ({ inactive = false, style = {}, ...props }) => {
  return (
    <SVG width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' style={{ ...style }} {...props}>
      <path
        d='M26 5H6C5.44772 5 5 5.44772 5 6V26C5 26.5523 5.44772 27 6 27H26C26.5523 27 27 26.5523 27 26V6C27 5.44772 26.5523 5 26 5Z'
        fill='none'
        stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M8 10H24' stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'} strokeWidth='2' strokeLinecap='round' />
      <path d='M8 14H24' stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'} strokeWidth='2' strokeLinecap='round' />
      <path d='M8 18H24' stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'} strokeWidth='2' strokeLinecap='round' />
      <path d='M8 22H24' stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'} strokeWidth='2' strokeLinecap='round' />
    </SVG>
  )
}
